import { KeyValue } from '@angular/common';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  SearchSort,
  SearchSortDirection,
  SearchSortFieldName,
  searchSortFieldNameLabels
} from '@forgerock/backstage-ui-core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { SearchParamsContainerComponent } from '../search-params-container/search-params-container.component';

@Component({
  selector: 'app-search-params-sort',
  templateUrl: './search-params-sort.component.html',
  styleUrls: [ './search-params-sort.component.scss' ],
  imports: [ NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem ]
})
export class SearchParamsSortComponent implements OnInit, OnDestroy {
  private container = inject(SearchParamsContainerComponent);

  sort = new SearchSort();
  options: KeyValue<SearchSort, string>[] = [
    {
      key: new SearchSort(SearchSortFieldName._score, SearchSortDirection.desc),
      value: searchSortFieldNameLabels._score
    },
    {
      key: new SearchSort(SearchSortFieldName.title, SearchSortDirection.asc),
      value: searchSortFieldNameLabels.title
    },
    {
      key: new SearchSort(SearchSortFieldName.updateTimestamp, SearchSortDirection.desc),
      value: searchSortFieldNameLabels.updateTimestamp
    }
  ];

  private subscription: Subscription;

  ngOnInit(): void {
    this.subscription = this.container.paramsChange.subscribe(params => this.sort = params.sort?.copy());
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setSort(sort: SearchSort): void {
    this.sort = sort;
    this.container.setParams({ sort: sort.copy() });
  }

}
